import React from 'react';
import { UsersList } from './pages/Users/UsersList';
import Organization from './pages/Organization/Organization';
import ViewDistributor from './pages/Organization/ViewDistributor';
import { ProductsList } from './pages/Products/ProductsList';
import { CategoriesList } from './pages/Products/CategoriesList';
import { VariantsList } from './pages/Products/VariantsList';
import { SizesList } from './pages/Products/SizesList';
import { BrandsList } from './pages/Products/BrandsList';
import { CollateralsList } from './pages/Products/CollateralsList';
import { PopList } from './pages/Products/PopList';
import { PriceChange } from './pages/Products/PriceChange';
import { BatchesList } from './pages/Products/BatchesList';
import { PackagingList } from './pages/Products/PackagingList';
import { UnitsList } from './pages/Products/UnitsList';
import { CratesList } from './pages/Products/CratesList';
import DistributorMargins from './pages/Products/DistributorMargins';
import RetailerMargins from './pages/Products/RetailerMargins';
import TradeMargins from './pages/Products/TradeMargins';
import Warehouses from './pages/Warehouses/Warehouses';
import ViewForWarehouses from './components/Products/ViewForWarehouses';
import AssignToWarehouse from './components/Products/AssignToWarehouse';
import EditWarehouses from './components/Warehouses/EditWarehouses';
import { SchemesList } from './pages/Scheme/SchemesList';
import { CreateScheme } from './pages/Scheme/CreateScheme';
import { SchemeDetails } from './pages/Scheme/SchemeDetails';
import { AssignScheme } from './pages/Scheme/AssignScheme';
import { SchemeHolder } from './pages/Scheme/SchemeHolder';
import { IncentivesList } from './pages/Incentive/IncentivesList';
import { CreateIncentive } from './pages/Incentive/CreateIncentive';
import { IncentiveDetails } from './pages/Incentive/IncentiveDetails';
import { AssignIncentive } from './pages/Incentive/AssignIncentive';
import { IncentiveHolder } from './pages/Incentive/IncentiveHolder';
import Dashboard from './pages/Dashboard/Dashboard';
import DistributorsList from './pages/Distributors/DistributorsList';
import AddDistributor from './pages/Distributors/AddDistributor';
import DistributorWalletList from './pages/DistributorWallet/DistributorWalletList';
import DistributorChannel from './pages/ControlPanel/DistributorChannel/DistributorChannel';
import SalesDocument from './pages/ControlPanel/SalesDocument/SalesDocument';
import SalesOrganization from './pages/ControlPanel/SalesOrganization/SalesOrganization';
import ITCa from './pages/ControlPanel/ITCa/ITCa';
import ZonesList from './pages/Organization/Zones/ZonesList';
import TerritoriesList from './pages/Organization/Territories/TerritoriesList';
import CitiesList from './pages/Organization/Cities/CitiesList';
import DeposList from './pages/Organization/Depos/DeposList';
import RoutesList from './pages/Organization/Routes/RoutesList';
import { OrdersList } from './pages/Orders/OrdersList';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import RolesPermission from './pages/RolesPermission/RolesPermission';
import Forbidden403 from './pages/Forbidden/Forbidden403';
import InventoryManagement from './pages/Inventory/InventoryManagement';
import SapSyncDashboard from './pages/SapSync/SapSyncDashboard';

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  title: string;
}

export const routesConfig: RouteConfig[] = [
  // Top level module routes
  { path: '/sap-sync', element: <ProtectedRoute permission="sap.sync"><SapSyncDashboard /></ProtectedRoute>, title: 'SAP Sync' },
  { path: '/sap_sync', element: <ProtectedRoute permission="sap.sync"><SapSyncDashboard /></ProtectedRoute>, title: 'SAP Sync' },
  { path: '/dashboard/sap-sync', element: <ProtectedRoute permission="sap.sync"><SapSyncDashboard /></ProtectedRoute>, title: 'SAP Sync' },
  { path: '/dashboard/sap_sync', element: <ProtectedRoute permission="sap.sync"><SapSyncDashboard /></ProtectedRoute>, title: 'SAP Sync' },
  { path: '/403', element: <Forbidden403 />, title: '403 Forbidden' },
  { path: '/admin/roles', element: <ProtectedRoute permission="roles.view"><RolesPermission /></ProtectedRoute>, title: 'Roles & Permissions' },
  { path: '/roles-permission', element: <ProtectedRoute permission="roles.view"><RolesPermission /></ProtectedRoute>, title: 'Roles & Permissions' },
  { path: '/roles_permission', element: <ProtectedRoute permission="roles.view"><RolesPermission /></ProtectedRoute>, title: 'Roles & Permissions' },
  { path: '/roles-permissions', element: <ProtectedRoute permission="roles.view"><RolesPermission /></ProtectedRoute>, title: 'Roles & Permissions' },
  { path: '/roles', element: <ProtectedRoute permission="roles.view"><RolesPermission /></ProtectedRoute>, title: 'Roles & Permissions' },
  { path: '/dashboard', element: <Dashboard />, title: 'ERP Dashboard' },
  { path: '/admin/users', element: <ProtectedRoute permission="users.view"><UsersList /></ProtectedRoute>, title: 'Multi-Role User Management' },
  { path: '/users', element: <ProtectedRoute permission="users.view"><UsersList /></ProtectedRoute>, title: 'Multi-Role User Management' },
  { path: '/distributor', element: <DistributorsList />, title: 'Distributors' },
  { path: '/distrubutor', element: <DistributorsList />, title: 'Distributors' },
  { path: '/distributor/add', element: <AddDistributor />, title: 'Add Distributor' },
  { path: '/distributor/edit/:id', element: <AddDistributor />, title: 'Edit Distributor' },
  { path: '/distributor/edit', element: <AddDistributor />, title: 'Edit Distributor' },
  { path: '/dashboard/add-distributor', element: <AddDistributor />, title: 'Add Distributor' },
  { path: '/dashboard/edit-distributor/:id', element: <AddDistributor />, title: 'Edit Distributor' },
  { path: '/distributor-wallet', element: <DistributorWalletList />, title: 'Distributor Wallet' },
  { path: '/distributor_wallet', element: <DistributorWalletList />, title: 'Distributor Wallet' },
  { path: '/distributor/wallet', element: <DistributorWalletList />, title: 'Distributor Wallet' },
  { path: '/organisation', element: <Organization />, title: 'Organisation' },
  { path: '/organisation/zones', element: <ZonesList />, title: 'Zones' },
  { path: '/organisation/territories', element: <TerritoriesList />, title: 'Territories' },
  { path: '/organisation/cities', element: <CitiesList />, title: 'Cities' },
  { path: '/organisation/depos', element: <DeposList />, title: 'Depos' },
  { path: '/organisation/routes', element: <RoutesList />, title: 'Routes' },
  { path: '/orders', element: <OrdersList />, title: 'Orders' },
  { path: '/control_panel', element: <DistributorChannel />, title: 'Distributor Channel' },
  { path: '/control-panel', element: <DistributorChannel />, title: 'Distributor Channel' },
  { path: '/control-panel/distributor-channel', element: <DistributorChannel />, title: 'Distributor Channel' },
  { path: '/control-panel/sale-document', element: <SalesDocument />, title: 'Sales Document' },
  { path: '/control-panel/sales-document', element: <SalesDocument />, title: 'Sales Document' },
  { path: '/control-panel/sales-organization', element: <SalesOrganization />, title: 'Sales Organization' },
  { path: '/control-panel/sale-organization', element: <SalesOrganization />, title: 'Sales Organization' },
  { path: '/control-panel/itca', element: <ITCa />, title: 'ITCa' },
  { path: '/distributor-margins', element: <DistributorMargins />, title: 'Distributor Margins' },
  { path: '/retailer-margins', element: <RetailerMargins />, title: 'Retailer Margins' },
  { path: '/trade-margins', element: <TradeMargins />, title: 'Trade Margins' },

  // Dashboard sub routes
  { path: '/home', element: <Dashboard />, title: 'ERP Dashboard' },
  { path: '/dashboard/users', element: <UsersList />, title: 'Users' },
  { path: '/dashboard/organisation', element: <Organization />, title: 'Organisation' },
  { path: '/dashboard/view-distributor', element: <ViewDistributor />, title: 'View Distributor' },
  { path: '/dashboard/warehouses', element: <Warehouses />, title: 'Warehouses' },
  { path: '/dashboard/edit-warehouse', element: <EditWarehouses />, title: 'Edit Warehouse' },

  // Inventory
  { path: '/inventory', element: <ProtectedRoute permission="inventory.view"><InventoryManagement /></ProtectedRoute>, title: 'Inventory Management' },
  { path: '/dashboard/inventory', element: <ProtectedRoute permission="inventory.view"><InventoryManagement /></ProtectedRoute>, title: 'Inventory Management' },

  // Products routes
  { path: '/products', element: <ProductsList />, title: 'Products list' },
  { path: '/products/categories-brands', element: <CategoriesList />, title: 'Categories list' },
  { path: '/products/list-varient', element: <VariantsList />, title: 'Variant list' },
  { path: '/products/list-size', element: <SizesList />, title: 'Sizes list' },
  { path: '/products/list-sizes', element: <SizesList />, title: 'Sizes list' },
  { path: '/products/sizes', element: <SizesList />, title: 'Sizes list' },
  { path: '/products/list-brands', element: <BrandsList />, title: 'Brands list' },
  { path: '/products/list-collaterals', element: <CollateralsList />, title: 'Collaterals list' },
  { path: '/products/list-pop', element: <PopList />, title: 'POP list' },
  { path: '/products/product-price', element: <PriceChange />, title: 'Price changes' },
  { path: '/products/list-batches', element: <BatchesList />, title: 'Batches list' },
  { path: '/products/list-packaging', element: <PackagingList />, title: 'Packaging list' },
  { path: '/products/list-packagings', element: <PackagingList />, title: 'Packaging list' },
  { path: '/products/packagings', element: <PackagingList />, title: 'Packaging list' },
  { path: '/products/list-units', element: <UnitsList />, title: 'Units list' },
  { path: '/crates', element: <CratesList />, title: 'Crates list' },
  { path: '/products/crates', element: <CratesList />, title: 'Crates list' },
  { path: '/products/list-crates', element: <CratesList />, title: 'Crates list' },
  { path: '/products/list-crate', element: <CratesList />, title: 'Crates list' },
  { path: '/products/distributor-margins', element: <DistributorMargins />, title: 'Distributor Margins' },
  { path: '/products/retailer-margins', element: <RetailerMargins />, title: 'Retailer Margins' },
  { path: '/products/trade-margins', element: <TradeMargins />, title: 'Trade Margins' },
  { path: '/products/view-for-warehouses', element: <ViewForWarehouses onBack={() => window.history.back()} />, title: 'View For Warehouses' },
  { path: '/products/assign-warehouse', element: <AssignToWarehouse />, title: 'Assign to Warehouse' },
  { path: '/products/view-for-warehouses', element: <ViewForWarehouses onBack={() => window.history.back()} />, title: 'View For Warehouses' },
  { path: '/products/assign-warehouse', element: <AssignToWarehouse />, title: 'Assign to Warehouse' },

  // Scheme routes
  { path: '/scheme', element: <SchemesList />, title: 'Scheme Details' },
  { path: '/scheme/create', element: <CreateScheme />, title: 'Create Scheme' },
  { path: '/scheme/new', element: <CreateScheme />, title: 'Create Scheme' },
  { path: '/scheme/details/:id', element: <SchemeDetails />, title: 'Scheme Details' },
  { path: '/scheme/details', element: <SchemeDetails />, title: 'Scheme Details' },
  { path: '/scheme/edit/:id', element: <CreateScheme />, title: 'Edit Scheme' },
  { path: '/scheme/edit', element: <CreateScheme />, title: 'Edit Scheme' },
  { path: '/assign-scheme', element: <AssignScheme />, title: 'Assign Schemes' },
  { path: '/scheme-holder', element: <SchemeHolder />, title: 'Scheme Holders' },

  // Incentive / Insentive routes
  { path: '/incentive', element: <IncentivesList />, title: 'Incentive Details' },
  { path: '/insentive', element: <IncentivesList />, title: 'Incentive Details' },
  { path: '/incentive/create', element: <CreateIncentive />, title: 'Create Incentive' },
  { path: '/insentive/create', element: <CreateIncentive />, title: 'Create Incentive' },
  { path: '/incentive/new', element: <CreateIncentive />, title: 'Create Incentive' },
  { path: '/insentive/new', element: <CreateIncentive />, title: 'Create Incentive' },
  { path: '/incentive/details/:id', element: <IncentiveDetails />, title: 'Incentive Details' },
  { path: '/insentive/details/:id', element: <IncentiveDetails />, title: 'Incentive Details' },
  { path: '/incentive/details', element: <IncentiveDetails />, title: 'Incentive Details' },
  { path: '/insentive/details', element: <IncentiveDetails />, title: 'Incentive Details' },
  { path: '/incentive/edit/:id', element: <CreateIncentive />, title: 'Edit Incentive' },
  { path: '/insentive/edit/:id', element: <CreateIncentive />, title: 'Edit Incentive' },
  { path: '/incentive/edit', element: <CreateIncentive />, title: 'Edit Incentive' },
  { path: '/insentive/edit', element: <CreateIncentive />, title: 'Edit Incentive' },
  { path: '/assign-incentive', element: <AssignIncentive />, title: 'Assign Incentive' },
  { path: '/assign-insentive', element: <AssignIncentive />, title: 'Assign Incentive' },
  { path: '/incentive-holder', element: <IncentiveHolder />, title: 'Incentive Holders' },
  { path: '/insentive-holder', element: <IncentiveHolder />, title: 'Incentive Holders' },

  // Other routes
  { path: '/report', element: null, title: 'Report Console' },
  { path: '/customer-report', element: null, title: 'Customer Analytics' },
  { path: '/notification', element: null, title: 'Alerts & Notifications' },
  { path: '/unapproved-outlets', element: null, title: 'Pending Outlets' },
];

